module.exports = __webpack_public_path__ + "static/filmdrop-laptop-campfire-17296acc376c142024e215d96dc843ac.png";